export default __webpack_public_path__ + "static/media/navbar-balance-orange.4dc95d32.svg";